import React from "react";

const UnassignedIcon = () => {
  return (
    <>
      <svg width="22" height="22" viewBox="0 0 22 22">
        <g id="Group_203" data-name="Group 203" transform="translate(-2 -2)">
          <path
            id="Path_2516"
            data-name="Path 2516"
            d="M15.18,10.94A3.451,3.451,0,0,0,15.5,9.5,3.5,3.5,0,0,0,12,6a3.451,3.451,0,0,0-1.44.32Z"
            transform="translate(1.137 0.531)"
            fill="#fff"
          />
          <path
            id="Path_2517"
            data-name="Path 2517"
            d="M13,2A11,11,0,1,0,24,13,11,11,0,0,0,13,2m0,14.3a10.941,10.941,0,0,0-6.754,2.332A8.759,8.759,0,0,1,6.059,7.61l3.146,3.146a3.817,3.817,0,0,0,3.289,3.289l2.42,2.42A11.056,11.056,0,0,0,13,16.3m6.941,2.09L7.61,6.059A8.692,8.692,0,0,1,13,4.2a8.785,8.785,0,0,1,6.941,14.19"
            fill="#fff"
          />
        </g>
      </svg>
    </>
  );
};

export default UnassignedIcon;
